<template>
    <div class="welcome-container">
      <div class="welcome-card-wrapper">
        
        <!-- Option 1 Card -->
        <div class="feature-card">
          <!-- Bind gradientIconStyle here -->
          <div class="card-glass-glow" :style="gradientIconStyle"></div>
          
          <div class="card-content">
            <div class="icon-floating-wrapper">
              <div class="icon-avatar" :style="gradientIconStyle">
                <v-icon size="56" color="white">mdi-cash-multiple</v-icon>
              </div>
            </div>
            <div class="text-content" v-html="description1"></div>
          </div>
        </div>
  
        <!-- Divider Badge -->
        <div class="divider-badge-wrapper">
          <div class="divider-line"></div>
          <span class="or-badge">OR</span>
          <div class="divider-line"></div>
        </div>
  
        <!-- Option 2 Card -->
        <div class="feature-card">
          <!-- Bind gradientIconStyle here -->
          <div class="card-glass-glow" :style="gradientIconStyle"></div>
          
          <div class="card-content">
            <div class="icon-floating-wrapper">
              <div class="icon-avatar" :style="gradientIconStyle">
                <v-icon size="56" color="white">mdi-account-check</v-icon>
              </div>
            </div>
            <div class="text-content" v-html="description2"></div>
          </div>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "WelcomeNotice",
    props: {
      description1: {
        type: String,
        default: `Select from <strong>"Add or Manage Invoices"</strong> to capture new Invoices or manage existing ones.`
      },
      description2: {
        type: String,
        default: `Select from <strong>"Clients Accounts & Payments"</strong> to add or manage clients, and to view or mark invoices paid.`
      }
    },
    computed: {
      gradientIconStyle() {
        return this.$store.getters.gradientIconStyle;
      },
      // Fallback/Custom gradient background style for 3D badges
      gradientBackgroundStyle() {
        return {
          background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)',
          boxShadow: '0 10px 20px -5px rgba(168, 85, 247, 0.4)'
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .welcome-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem 1rem;
    perspective: 1000px; /* Enables 3D perspective space */
  }
  
  .welcome-card-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    max-width: 520px;
  }
  
  /* Feature Cards with 3D Hover & Tilt Effect */
  .feature-card {
    position: relative;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 20px;
    padding: 1.75rem;
    box-shadow: 0 15px 35px -5px rgba(0, 0, 0, 0.05),
                0 5px 15px -5px rgba(0, 0, 0, 0.03);
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275),
                box-shadow 0.4s ease,
                border-color 0.4s ease;
    transform-style: preserve-3d;
    cursor: pointer;
  }
  
  .feature-card:hover {
    transform: translateY(-8px) rotateX(4deg) rotateY(-2deg) scale(1.02);
    box-shadow: 0 25px 45px -10px rgba(99, 102, 241, 0.18),
                0 10px 20px -5px rgba(0, 0, 0, 0.04);
    border-color: rgba(168, 85, 247, 0.4);
  }
  
  /* Subtle Gradient Glow Behind Card */
  .card-glass-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 20px;
  /* background removed from here; controlled via :style */
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
}

/* On hover, reveal a soft tint (0.08 / 8%) of your store's gradient */
.feature-card:hover .card-glass-glow {
  opacity: 0.08;
}
  
  .card-content {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    transform: translateZ(20px); /* Lifts elements forward in 3D space */
  }
  
  /* Floating 3D Icon Styling */
  .icon-floating-wrapper {
    animation: float 4s ease-in-out infinite;
    flex-shrink: 0;
  }
  
  .feature-card:nth-child(3) .icon-floating-wrapper {
    animation-delay: 2s; /* Stagger float animation for second card */
  }
  
  .icon-avatar {
    width: 64px;
    height: 64px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }
  
  .feature-card:hover .icon-avatar {
    transform: scale(1.1) rotate(5deg) translateZ(10px);
  }
  
  /* Text Content Styling */
  .text-content {
  
    font-size: 0.975rem;
    line-height: 1.6;
  }
  
  ::v-deep .text-content strong {
    color: #0f172a;
    font-weight: 600;
    background: linear-gradient(135deg, #1207ed, #ea5233);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  /* Modern "OR" Divider Badge */
  .divider-badge-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin: 0.25rem 0;
  }
  
  .divider-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(203, 213, 225, 0.8), transparent);
  }
  
  .or-badge {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: #64748b;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 0.35rem 0.85rem;
    border-radius: 9999px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
  }
  
  /* Keyframe Floating Animation */
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-6px);
    }
  }
  
  /* Responsive adjustments */
  @media (max-width: 480px) {
    .card-content {
      flex-direction: column;
      text-align: center;
    }
  }
  </style>